// migrated 1:1 from @nexato/nx-core-module, #688
import { Activity } from "../../../entities/activity/activity";
import { ActivityComponent } from "./activityComponent";
import { Component, input } from '@angular/core';

@Component({
  selector: 'app-issue-dueDateTime-set',
  template: `
    <!-- {{activity() | json }} -->
    <ng-container *ngIf="activity()?.viewModel?.oldDueDateTime && !activity()?.viewModel?.newDueDateTime; else dueDateTimeChanged">
    <b>{{activity()?.actor?.displayName}}</b> hat die Fälligkeit <b>entfernt</b>&nbsp;<app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-container>
    <ng-template #dueDateTimeChanged>
      <b>{{activity()?.actor?.displayName}}</b> hat die Fälligkeit auf <b>{{activity()?.viewModel?.newDueDateTime | date:'EEE, dd.MM.yyyy'}}</b> geändert <app-relative-time [timestamp]="activity()?.createdDateTime" />
    </ng-template>
  `
})
export class IssueDueDateTimeSetComponent implements ActivityComponent {

  readonly activity = input.required<Activity>();
  readonly ownerId = input<string>();
}
